import {
  LoadAssessmentActivityData,
  LoadAssessmentActivityDataCompleted,
  LoadAssessmentActivityDataFailed,
} from './activity-report-load.action';

export enum ActivityReportActionType {
  LoadAssessmentActivityData              = 'LOAD_ASSESSMENT_ACTIVITY_DATA',
  LoadAssessmentActivityDataCompleted     = 'LOAD_ASSESSMENT_ACTIVITY_DATA_COMPLETED',
  LoadAssessmentActivityDataFailed        = 'LOAD_ASSESSMENT_ACTIVITY_DATA_FAILED',
}

export type ActivityReportActions =

  LoadAssessmentActivityData |
  LoadAssessmentActivityDataCompleted |
  LoadAssessmentActivityDataFailed;
